import { render } from "./CarterChargerStatusDashboard.vue?vue&type=template&id=2c2d64cc&scoped=true"
import script from "./CarterChargerStatusDashboard.vue?vue&type=script&lang=js"
export * from "./CarterChargerStatusDashboard.vue?vue&type=script&lang=js"

import "./CarterChargerStatusDashboard.vue?vue&type=style&index=0&id=2c2d64cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2d64cc"]])

export default __exports__